import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import {
  CurrentUserOutputDto,
  SessionClient,
} from '../remote-clients/remote-client';

@Injectable()
export class SessionService {
  private static currentUser: CurrentUserOutputDto;

  constructor(private readonly _sessionClient: SessionClient) { }

  private async loadUserInfo(): Promise<void> {
    const entityResult = await firstValueFrom(
      this._sessionClient.currentUser()
    );
    SessionService.currentUser = entityResult.entity!;
  }

  async getCurrentUser(): Promise<CurrentUserOutputDto> {
    if (!SessionService.currentUser) {
      await this.loadUserInfo();
    }

    return SessionService.currentUser;
  }
}
